module.exports = __webpack_public_path__ + "media/images/patent/z_6-e5e02a19e930fdb3ba461bab9d04f574.png";